import DataTable from 'components/ui/DataTable/data-table';
import Modal from 'components/ui/Modal/modal';
import { useFormik } from 'formik';
import React, { Fragment, useState } from 'react';

import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import useToggle from 'hooks/useToggle';
import { toast } from 'react-toastify';
import {
  IEvaluationTrainee,
  useCreateResourcesMutation,
  useDeleteResourcesMutation,
  useListResourcesQuery,
  useUpdateResourcesMutation
} from 'redux/reducers/assignmentEvalutaion';
import AddResourcesForm from './ResourcesModal';
import { ResourcesInitialValues, ResourcesSchemaValidation } from './schema';
import { backendURL } from 'redux/reducers/settings';
import { Link } from 'react-router-dom';

interface IEvaluationDataTable {
  tableHeaders?: () => React.ReactNode;
  onEditClicked: (data: IEvaluationTrainee) => void;
  onDeleteClicked: (data: IEvaluationTrainee) => void;
  onViewClicked: (data: IEvaluationTrainee) => void;
  onAddQuestions: (data: IEvaluationTrainee) => void;
}

const ResourcesList = ({ selectedData }: any) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data: EvaluationQueryData, isLoading } = useListResourcesQuery(
    Number(selectedData?.id) || 0
  );

  const [selectedRowData, setselectedRowData] = useState<any>();
  const canNext = false;
  const canPrevious = false;

  const columns: any = [
    {
      Header: 'Name',
      accessor: 'name'
    },
    {
      Header: 'Resource',
      Cell: (data: any) => {
        return (
          <>
            <img
              src={backendURL + data.row.original?.resource_file}
              alt="edit"
              style={{ marginRight: '10px', width: '50px', height: '50px' }}
              onClick={() => onEditClicked(data.row.original)}
            />
            <a href={backendURL + data.row.original?.resource_file} target="_blank">
              View Resource
            </a>
          </>
        );
      }
    },

    {
      Header: '  Actions',
      Cell: (data: any) => {
        return (
          <>
            <img
              src={require('../../NewEvaluation/Images/edit.png')}
              alt="edit"
              style={{ marginRight: '10px' }}
              onClick={() => onEditClicked(data.row.original)}
            />
            <img
              src={require('../../NewEvaluation/Images/Vector.png')}
              alt="delete"
              onClick={() => onDeleteClicked(data.row.original.id)}
            />
          </>
        );
      }
    }
  ];
  const onEditClicked = (data: any) => {
    setselectedRowData(data);
    setshowAddQuestionModal(true);
  };
  const [deleteFeedbackEvaluationCriteria, { isLoading: isDeletingEvaluationCriteria }] =
    useDeleteResourcesMutation();
  const [deleteModal, toggleDeleteModal] = useToggle(false);

  const onDeleteClicked = (data: IEvaluationTrainee) => {
    setselectedRowData(data);
    toggleDeleteModal();
  };
  const onDeleteConfirmEvaluationCriteria = () => {
    selectedRowData &&
      deleteFeedbackEvaluationCriteria(selectedRowData)
        .unwrap()
        .then((data: any) => {
          toast.success('Deleted Successfully');
          //   setFeedbackInitialForm(EvaluationCriteriaInitialValues);
          toggleDeleteModal();
        })
        .catch((err: any) => {
          toast.error('Error');
        });
  };
  const [createFeedbackEvaluationCriteria, { isLoading: isCreatingEvaluationCriteria }] =
    useCreateResourcesMutation();

  const [updateFeedbackEvaluationCriteria, { isLoading: isUpdatingEvaluationCriteria }] =
    useUpdateResourcesMutation();

  const addAssignmentformik = useFormik({
    enableReinitialize: true,
    validationSchema: ResourcesSchemaValidation,
    initialValues: ResourcesInitialValues,

    onSubmit: (values, { resetForm }) => {
      let executeFunc = values?.id
        ? updateFeedbackEvaluationCriteria
        : createFeedbackEvaluationCriteria;

      executeFunc(values)
        .unwrap()
        .then((data: any) => {
          toast.success('Created Successfully');
          resetForm();
          setshowAddQuestionModal(!showAddQuestionModal);
        })
        .catch((err: any) => {
          resetForm();
        });
      resetForm();
    }
  });

  const [showAddQuestionModal, setshowAddQuestionModal] = useToggle(false);
  const onAddQuestions = (data: any) => {
    // setSelectedData(data);
    setshowAddQuestionModal(!showAddQuestionModal);
  };

  return (
    <Fragment>
      <ConfirmationModal
        isOpen={deleteModal}
        onClose={toggleDeleteModal}
        onConfirm={onDeleteConfirmEvaluationCriteria}
        title="Delete Confirmations"
        isLoading={isDeletingEvaluationCriteria}>
        <>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">You want to Remove this Record ?</p>
          </div>
        </>
      </ConfirmationModal>
      <form onSubmit={addAssignmentformik.handleSubmit}>
        <Modal
          title={`${selectedRowData ? 'Update' : 'Add'} Resources`}
          isModalOpen={showAddQuestionModal}
          closeModal={setshowAddQuestionModal}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <PrimaryButton title="Add" type="submit" isLoading={isCreatingEvaluationCriteria || isUpdatingEvaluationCriteria} />
              <SecondaryButton onClick={setshowAddQuestionModal} title="Discard" />
            </div>
          )}>
          <AddResourcesForm
            isloading={isCreatingEvaluationCriteria}
            evId={selectedData?.id}
            selectedData={selectedRowData}
            formik={addAssignmentformik}
          />
        </Modal>
      </form>

      <div className="list form-check-all">
        <DataTable
          columns={columns}
          isLoading={isLoading}
          data={
            EvaluationQueryData?.data && EvaluationQueryData?.data?.length > 0
              ? EvaluationQueryData?.data
              : []
          }
          tableHeaders={() => (
            <>
              <PrimaryButton
                title="Add Resources"
                iconName="ri-add-line align-bottom me-1"
                onClick={() => {
                  setselectedRowData(undefined);
                  setshowAddQuestionModal();
                }}
                type="button"
              />
            </>
          )}
          pagination={{
            canNext,
            canPrevious,
            prevPage: () => {
              if (canPrevious) {
                page > 1 && setPage(page - 1);
              }
            },
            nextPage: () => {
              if (canNext) {
                setPage(page + 1);
              }
            }
          }}
        />
      </div>
    </Fragment>
  );
};

export default ResourcesList;
